import { Components } from 'api/gen/client'
import { tableColumns } from './structure'
import { Table } from 'antd'
interface InvoiceLinesProps {
  invoice: Components.Schemas.Invoice
}

const InvoiceLines = ({ invoice }: InvoiceLinesProps) => {
  return (
    <Table
      dataSource={invoice.invoice_lines}
      columns={tableColumns}
      pagination={false}
    />
  )
}

export default InvoiceLines
